<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

import Button from 'dashboard/components-next/button/Button.vue';
import TabBar from 'dashboard/components-next/tabbar/TabBar.vue';
import SettingsTab from './components/SettingsTab.vue';
import BusinessInfoTab from './components/BusinessInfoTab.vue';
import FaqsTab from './components/FaqsTab.vue';
import WebsitesTab from './components/WebsitesTab.vue';
import FilesTab from './components/FilesTab.vue';
import SkillsTab from './components/SkillsTab.vue';
import UiSkillsTab from './components/UiSkillsTab.vue';
import AllowlistTab from './components/AllowlistTab.vue';
import ConnectorsTab from './components/ConnectorsTab.vue';
import TestTab from './components/TestTab.vue';

defineProps({
  hookId: { type: [String, Number], required: true },
  inboxName: { type: String, default: '' },
});

defineEmits(['disconnect']);

const { t } = useI18n();
const router = useRouter();

const tabComponents = [
  SettingsTab,
  BusinessInfoTab,
  FaqsTab,
  WebsitesTab,
  FilesTab,
  SkillsTab,
  UiSkillsTab,
  AllowlistTab,
  ConnectorsTab,
  TestTab,
];

const tabs = computed(() => [
  { label: t('INTEGRATION_SETTINGS.META_BUSINESS_AGENT.TABS.SETTINGS') },
  { label: t('INTEGRATION_SETTINGS.META_BUSINESS_AGENT.TABS.BUSINESS_INFO') },
  { label: t('INTEGRATION_SETTINGS.META_BUSINESS_AGENT.TABS.FAQS') },
  { label: t('INTEGRATION_SETTINGS.META_BUSINESS_AGENT.TABS.WEBSITES') },
  { label: t('INTEGRATION_SETTINGS.META_BUSINESS_AGENT.TABS.FILES') },
  { label: t('INTEGRATION_SETTINGS.META_BUSINESS_AGENT.TABS.SKILLS') },
  { label: t('INTEGRATION_SETTINGS.META_BUSINESS_AGENT.TABS.UI_SKILLS') },
  { label: t('INTEGRATION_SETTINGS.META_BUSINESS_AGENT.TABS.ALLOWLIST') },
  { label: t('INTEGRATION_SETTINGS.META_BUSINESS_AGENT.TABS.CONNECTORS') },
  { label: t('INTEGRATION_SETTINGS.META_BUSINESS_AGENT.TABS.TEST') },
]);

const activeTabIndex = ref(0);
const activeTabComponent = computed(() => tabComponents[activeTabIndex.value]);

const goBack = () => {
  router.push({ name: 'settings_applications' });
};
</script>

<template>
  <div class="flex flex-col gap-4">
    <div class="flex items-center justify-between flex-wrap gap-2">
      <div class="flex items-center gap-3">
        <Button
          icon="i-lucide-arrow-left"
          slate
          faded
          size="sm"
          @click="goBack"
        />
        <div>
          <h2 class="text-lg font-medium text-n-slate-12 m-0">
            {{ t('INTEGRATION_SETTINGS.HEADER') }}
          </h2>
          <p v-if="inboxName" class="text-sm text-n-slate-11 m-0">
            {{ inboxName }}
          </p>
        </div>
      </div>
      <Button
        ruby
        faded
        :label="t('INTEGRATION_APPS.DISCONNECT.BUTTON_TEXT')"
        @click="$emit('disconnect')"
      />
    </div>
    <TabBar
      :tabs="tabs"
      :initial-active-tab="activeTabIndex"
      @tab-changed="tab => (activeTabIndex = tabs.indexOf(tab))"
    />
    <component :is="activeTabComponent" :hook-id="hookId" />
  </div>
</template>
